module.exports = __webpack_public_path__ + "img/np.np3b3316c.svg";